import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
// import { ChartsModule } from 'ng2-charts';
import { NgChartsModule } from 'ng2-charts';
import { FileUploadModule } from 'ng2-file-upload';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ToastrModule } from 'ngx-toastr';
// import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { NgtreegridModule } from 'ngtreegrid';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';
// import { ToastrModule } from 'ng6-toastr-notifications';
// import { MdHeaderComponent } from '../md/md-layouts/md-header/md-header.component';

import { SharedRoutingModule } from './shared-routing.module';
// import { WorkflowDefinitionComponent } from '../md/workflow-definition/workflow-definition.component';
import { WorkflowDefinitionComponent } from '../md/workflow-definition/workflow-definition.component';
//oc
import { VendorsComponent } from '../md/vendors/vendors.component';
//ec
// import { MdHeaderComponent } from '../md/md-layouts/md-header/md-header.component';
import { NewHeaderComponent } from '../md/new-header/new-header.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { MasterEditorComponent } from '../md/master-editor/master-editor.component'

import { RemoveHyperlinkDirective } from '../directives/remove-hyperlink.directive';
import { LayoutComponent } from '../md/utilities/utility-layout/layout/layout.component';
// import { HeaderComponent } from '../md/utilities/header/header.component'
import { HeaderComponent } from '../md/utilities/utility-layout/header/header.component'
import { FooterComponent } from '../md/utilities/utility-layout/footer/footer.component'
// import { ComputerSidebarComponent } from '../computer/computer-layout/computer-sidebar/computer-sidebar.component';
import { UtilityHierarchyComponent } from '../md/utilities/administration/authorisation/utility-hierarchy/utility-hierarchy.component';
import { UtilityRoleAuthorisationComponent } from '../md/utilities/administration/authorisation/utility-role-authorisation/utility-role-authorisation.component';
import { UtilityRoleCreateComponent } from '../md/utilities/administration/authorisation/utility-role-create/utility-role-create.component';
import { UtilityCodeValueComponent } from '../md/utilities/administration/master-data/utility-code-value/utility-code-value.component';
import { UtilityFieldComponent } from '../md/utilities/administration/master-data/utility-field/utility-field.component';
import { UtilityDeductionComponent } from '../md/utilities/administration/master-data/utility-deduction/utility-deduction.component';
import { UtilityDataAssignmentComponent } from '../md/utilities/administration/authorisation/utility-data-assignment/utility-data-assignment.component';
import { WorkComponent } from '../accounts/setting/work/work.component';
import { MatMenuModule } from '@angular/material/menu';
import { AcmsSidebarComponent } from '../acms/amcs-layout/acms-sidebar/acms-sidebar.component';
import { CommonMatTableComponent } from '../acms/acms-utility/common-mat-table/common-mat-table.component';
import { PaginatorComponent } from '../acms/acms-utility/paginator/paginator.component';
import { OverlayModule  } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  declarations: [
    //oc
    WorkflowDefinitionComponent,
    NewHeaderComponent,
    // MdHeaderComponent,
    VendorsComponent,
    SpinnerComponent,
    MasterEditorComponent,
    RemoveHyperlinkDirective,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    // ComputerSidebarComponent, 
    // StmSidebarComponent,
    UtilityHierarchyComponent,
    UtilityRoleAuthorisationComponent,
    UtilityRoleCreateComponent,
    UtilityDeductionComponent,
    UtilityFieldComponent,
    UtilityCodeValueComponent,
    UtilityDataAssignmentComponent,
    WorkComponent,
    AcmsSidebarComponent,
    CommonMatTableComponent,
    PaginatorComponent
    // AdministrationComponent
    //ec
  ],
  exports: [
    //oc
    WorkflowDefinitionComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    NewHeaderComponent,
    VendorsComponent,
    MasterEditorComponent,
    SpinnerComponent,
    // DataAssignmentComponent,
    RemoveHyperlinkDirective,
    // ComputerSidebarComponent,
    
    UtilityHierarchyComponent,
    UtilityRoleAuthorisationComponent,
    UtilityRoleCreateComponent,
    UtilityDeductionComponent,
    UtilityFieldComponent,
    UtilityCodeValueComponent,
    UtilityDataAssignmentComponent,
    WorkComponent,
    AcmsSidebarComponent, 
     CommonMatTableComponent,
    PaginatorComponent
    // AdministrationComponent
    //ec
    // MdHeaderComponent,
  ],

  imports: [
    CommonModule,
    SharedRoutingModule,

    NgSelectModule,
    NgChartsModule,
    FileUploadModule,
    MatInputModule,
    // NgbModule,
    MatSlideToggleModule,
    FormsModule,
    // NgtreegridModule,
    MatStepperModule,
    MatMenuModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    OverlayModule,
    PortalModule,
    MatTabsModule,
    ToastrModule.forRoot(),
  ]
})
export class SharedModule { }
